import { Component, OnInit, Input, Output, EventEmitter,ViewChild,ElementRef } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { UserSettings } from './usersettings';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDateStruct, NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import bb from "billboard.js";
var moment = require('moment');
import Swal from 'sweetalert2';
//import { index } from 'server/api/messagesystem/messagesystem.controller';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { CustomDateFormat } from '../main/CustomDateFormat';
import { DatePipe } from '@angular/common';




@Component({
    selector: 'cust-template-Global',
    template: require('./customerTemplateGlobal.html'),
    styles: [`@media (max-width: 1600px) {.data-show .modal-content{min-height:172px}}`]
})
export class CustomerTemplateGlobalComponent implements OnInit {
   
    @Input('customerList1') customerList1: any;
    @Input("cValue") cValue :any;
    @Input( "dValue")  dvalue :any;
    @Output() SelectedCustomer = new EventEmitter();
    @ViewChild('OS') OS: ElementRef;
    @ViewChild('CustomerNotespopup') CustomerNotespopup: ElementRef;
    @ViewChild('cuatInfopopup') cuatInfopopup: ElementRef;
    @ViewChild('SalesHistorypopup') SalesHistorypopup: ElementRef;
    @Input('filterType') filterType: any;
    @Input('SerachValue') SerachValue: any;
    @Input('LastSelectedId') LastSelectedId: any;
    @ViewChild('ledger') ledger: ElementRef;
    @ViewChild('expiryLedger') expiryLedger: ElementRef;

    static parameters = [ UtilityService, HttpClient, NgbModal, HotkeysService, BsDatepickerConfig ,CustomDateFormat,DatePipe];
    dateFormat: any;
    bsConfig: any;
    constructor(public utilityService: UtilityService,private http: HttpClient,private modalService: NgbModal,  private hotkeysService: HotkeysService, public _bsDatepickerConfig: BsDatepickerConfig,public customDateFormat: CustomDateFormat,public datePipe: DatePipe) {
        this.http = http;
        this.modalService = modalService;
        this.hotkeysService = hotkeysService;

        this.dateFormat = JSON.parse(localStorage.getItem('permission'))[0];
        this.bsConfig = Object.assign({}, { dateInputFormat: this.dateFormat.dateInputFormat, containerClass: this.dateFormat.dateColorTheme });
        this._bsDatepickerConfig.dateInputFormat = this.dateFormat.dateInputFormat;
      //   console.log("this.bsConfig", this.bsConfig);
    }

    modalReference: NgbModalRef;
    updateHSNReference: NgbModalRef;
    modalLadgerReference: NgbModalRef;

    gridApiCust: any;
    gridColumnApiCust: any;
    selectedCustomer : any;
    paginationConf:any;
    customerList: any;
    customerDef1: any;
    selectedCustomerInfo: any;
    defaultColDef:any;
    d:any;
    public hotkeyList: Hotkey[];
    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        backdrop: `rgba(30, 30, 37, 0.4)`
    });
    orderSearch: any;
    public rowClassRules: any;
    rowSelectionSingle: string;
    searchValue: any;
    unitInfo: any;
    ngOnInit(): void {
      //   console.log('product template init!');
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.paginationConf = true;
        // setTimeout( () => {
        //     $('.modal-content').addclass('updateheight');
        //   }, 1000);
        // $(document).ready(function () {
        //     $('.modal-content').addclass('updateheight');
        // });

        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        this.initHotkeys();

      //   console.log("CustomerInformation   ========>",this.unitInfo);

        this.ledgerSearch = {};
        this.ledgerSearch.filtertype = 'C';
        this.ledgerSearch.From_Date = this.oneMonthAgo();
        this.ledgerSearch.To_Date = new Date();

        this.orderSearch = {};
        this.orderSearch.filtertype = 'C';
        this.orderSearch.From_Date = this.oneMonthAgo();
        this.orderSearch.To_Date = new Date();
    }
    toastWarningMsg(msg) {
        this.toast({
            type: 'warning',
            title: msg,
            timer: 3000
        });
    }

    initHotkeys() {
        this.hotkeyList = [];
        const altd = new Hotkey('alt+d', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="Customer_Code"]').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altd);
        this.hotkeysService.add(altd);

        const altn = new Hotkey('alt+n', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="Customer_LegalName"]').trigger('click');
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altn);
        this.hotkeysService.add(altn);

        const alta = new Hotkey('alt+a', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="altCode"]').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alta);
        this.hotkeysService.add(alta);

        const alto = new Hotkey('alt+o', (event: KeyboardEvent): boolean => {
            this.outstandingClick();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alto);
        this.hotkeysService.add(alto);

        const altw = new Hotkey('alt+w', (event: KeyboardEvent): boolean => {
            this.movepopup(this);
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altw);
        this.hotkeysService.add(altw);

        const altu = new Hotkey('alt+u', (event: KeyboardEvent): boolean => {
            this.OpenCustomerNotesPopup();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altu);
        this.hotkeysService.add(altu);

        const alth = new Hotkey('alt+h', (event: KeyboardEvent): boolean => {
            this.OpenSalesHistoryPopup(this.SalesHistorypopup);
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alth);
        this.hotkeysService.add(alth);

        const altc = new Hotkey('home', (event: KeyboardEvent): boolean => {
            this.clearAllFilter();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altc);
        this.hotkeysService.add(altc);

        const altl = new Hotkey('alt+l', (event: KeyboardEvent): boolean => {
            this.ledgerModal(this.ledger);
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altl);
        this.hotkeysService.add(altl);

        const alte = new Hotkey('alt+e', (event: KeyboardEvent): boolean => {
            this.expiryLedgerModal(this.expiryLedger);
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alte);
        this.hotkeysService.add(alte);

    }
    
    
    ngAfterViewInit() {
        this.paginationConf = UserSettings.enablePagination;
    }
    onGridReadyCust(params) {
        var parent = this;
        $( "#filter-text-box").keypress(function(event) {
            if (event.keyCode == 13) {
                parent.custSelectionMain(parent);
            }
        });

        $(".radio-label").change(function () {
            var select = $(this).val(); 
            $("input#filter-text-box").val("");
            parent.gridApiCust.setFilterModel(null);
            parent.gridApiCust.onFilterChanged();
            //this.gridApiCust.getModel().getRow(0).setSelected(true);

            if (select == 'Customer_Code') {
                $("input[id=filter-text-box]").attr("placeholder", "Search Customer By Code").blur();
            } else if (select == 'Customer_LegalName') {
                $("input[id=filter-text-box]").attr("placeholder", "Search Customer By Name").blur();
            } 
            else if (select == 'altCode') {
                $("input[id=filter-text-box]").attr("placeholder", "Search Customer By AltCode").blur();
            } 
            setTimeout(() => {
                $('#filter-text-box').focus();
            }, 200);
        });

        if(!this.filterType){
            this.filterType = "Customer_LegalName";
        }
        $(document).ready(function(){
            if (parent.filterType == 'Customer_Code') {
                $("input[id=filter-text-box]").attr("placeholder", "Search Customer By Code").blur();
            } else if (parent.filterType == 'Customer_LegalName') {
                $("input[id=filter-text-box]").attr("placeholder", "Search Customer By Name").blur();
            } 
            else if (parent.filterType == 'altCode') {
                $("input[id=filter-text-box]").attr("placeholder", "Search Customer By AltCode").blur();
            }
            setTimeout(() => {
                $('#filter-text-box').focus(); 
            }, 200);
        });
       

        this.customerDef1 = [
            { headerName: 'Code', field: 'Customer_Code', width: 120},
            { headerName: 'Alt Code', field: 'altCode', width: 120 },
            { headerName: 'Customer Name', field: 'Customer_LegalName', width: 280 },           
            { headerName: 'Address', field: 'Customer_Address1', width: 340 },
            { headerName: 'Contact', field: 'Customer_Mobile', width: 120 },
            { headerName: 'Area', field: 'Area_Name', width: 100 },
            { headerName: 'City', field: 'City_Desc', width: 100 },
            { headerName: 'State', field: 'State_Desc', width: 100 },
            { headerName: 'Email ID', field: 'Customer_EmailID', width: 90 },
         ];
       
        this.customerList = this.customerList1;
      //   console.log('customerList1', this.customerList);
      //   console.log("param on ready:", params);
        this.gridApiCust = params.api;
        this.gridColumnApiCust = params.columnApi;
        setTimeout( () => {
            //this.gridApiCust.sizeColumnsToFit();
            /*  this.gridColumnApiCust= this.gridApiCust.getModel().getRow(0).setSelected(true);
              //   console.log(this.gridColumnApiCust);
              //   console.log(this.selectedCustomerInfo); */
        
            this.gridColumnApiCust = params.columnApi;
            this.gridApiCust.sizeColumnsToFit();
            var index = 0;
          //   console.log('this.SerachValue : ',this.SerachValue);
            if (this.LastSelectedId) {
                index = this.customerList1.map(item => item.Product_ID).indexOf(this.LastSelectedId);
                if (this.gridApiCust.getInfiniteRowCount() < index) {
                    this.gridApiCust.setInfiniteRowCount(index, false);
                }
                this.gridApiCust.ensureIndexVisible(index);
                this.gridApiCust.setFocusedCell(index, "Customer_LegalName");
            }
            $('#prodfilter-text-box').focus().select();
            if(this.SerachValue){
                this.searchValue = this.SerachValue;
                this.quickSearch("", "customer");
            } else {
                this.selectedCustomerInfo = this.gridApiCust.getModel().getRow(0).setSelected(true);
                                        
            }
        }, 100);
  //   this.gridColumnApiCust.autoSizeColumns(allColumnIds);
   
     this.defaultColDef = {
         resizable: true,
     };
   
     if(this.SerachValue){
        this.searchValue = this.SerachValue;
        this.quickSearch("", "customer");
    } else {
        
        this.selectedCustomerInfo = this.gridApiCust.getModel().getRow(0).setSelected(true);
    }
        var myInputCust = document.getElementById("customermaster1");
        let self = this;
        this.custFilterd = this.gridApiCust.getModel().getRowCount().toLocaleString();
        this.defaultColDef = {
            resizable: true,
            sortable: true,
        };
        $("#customermaster1").keypress(function (event) {
          //   console.log("Handler for .keypress() called:", event);
        });
        // myInputCust.addEventListener("keydown", function (event) {
        //   //   console.log("event", event);
        //     if (event.keyCode == 13) {
        //       //   console.log("keydown", event);
        //         self.custSelectionMain(self);
        //     } else if (event.keyCode == 8) {
        //         setTimeout(() => {
        //             $('#filter-text-box').focus().select();
        //         }, 200);
        //     } else if (event.keyCode >= 65 && event.keyCode <= 90) {
        //         $('#filter-text-box').focus().select();
        //     }
        // });
    }
    gridEventDown(event) {
        if (event.keyCode == 13) {
          //   console.log("keydown", event);
            this.custSelectionMain(this);
        } else if (event.keyCode == 8) {
            setTimeout(() => {
                $('#filter-text-box').focus().select();
            }, 200);
        } else if (event.keyCode >= 65 && event.keyCode <= 90) {
            $('#filter-text-box').focus().select();
        }
    }
    private custSelectionMain(self: this) {
        let selectedRows = self.gridApiCust.getSelectedRows();
        let cust = selectedRows[0];
      //   console.log("selected cust:", selectedRows[0]);

        // if(cust.CreditDays == 0 || cust.CreditDays == '' || cust.CreditDays == undefined){
        //     this.toastWarningMsg("Credit Days should be greater than zero");
        //     return;
        // }
        // if(cust.CreditLimit == 0 || cust.CreditLimit == '' || cust.CreditLimit == undefined){
        //     this.toastWarningMsg("Credit limit should be greater than zero");
        //     return;
        // }
        if (cust != undefined) {
          //   console.log('selected ccustomer:', cust);
            this.SelectedCustomer.emit(cust);
        }

       
       
    }
    invoiceInfo: any;
    todayD: any;
    invoiceInfo1: any;
    Customer_GSTNo: any;
    Customer_Name: any;
    Customer_Address1: any;
    Customer_Full_Address: any;
    Customer_Mobile: any;
    Customer_Phone: any;
    Customer_EmailID: any;
    tax_Payer_type: any;
    DLNo_1: any;
    TCS: any;
    CreditLimit: any;
    CreditDays: any;
    TradeDiscount: any;
    TradeMode_Desc: any;
    Customer_ID: any;
    custFilterd: any;
    busy: Subscription;

    custSelected(event) {
        let selectedRowCust = this.gridApiCust.getSelectedRows();
      //   console.log("selectedRows", selectedRowCust);
        this.selectedCustomerInfo = selectedRowCust[0];
        // if(this.selectedCustomerInfo.Customer_Status == 'Unblocked'){
        //     this.ShowContetnBlock = false;
        // }else if(this.selectedCustomerInfo.Customer_Status == 'Blocked'){
        //     this.ShowContetnBlock = true;
        // }else{
        //     this.ShowContetnBlock = false;
        // }

        this.Customer_GSTNo = this.selectedCustomerInfo.Customer_GSTNo;
        this.Customer_Name = this.selectedCustomerInfo.Customer_Name;
        this.Customer_Address1 = this.selectedCustomerInfo.Customer_Address1;
        this.Customer_Full_Address = this.selectedCustomerInfo.Customer_Full_Address;
        this.Customer_Mobile = this.selectedCustomerInfo.Customer_Mobile;
        this.Customer_Phone = this.selectedCustomerInfo.Customer_Phone;
        this.Customer_EmailID = this.selectedCustomerInfo.Customer_EmailID;
        this.tax_Payer_type = this.selectedCustomerInfo.TaxPayer_Type;
        this.DLNo_1 = this.selectedCustomerInfo.DLNo_1;
        this.CreditLimit = this.selectedCustomerInfo.CreditLimit;
        this.CreditDays = this.selectedCustomerInfo.CreditDays;
        this.TradeDiscount = this.selectedCustomerInfo.TradeDiscount;
        this.TradeMode_Desc = this.selectedCustomerInfo.TradeMode_Desc;
        this.Customer_ID = this.selectedCustomerInfo.Customer_ID;
        this.TCS = (this.selectedCustomerInfo.TCS_Applicable ==0 ? 'No' : 'Yes' );

        //console.log("Block Content ===> ", this.ShowContetnBlock);
        this.selectedCustomerInfo.LastInvoiceDays = 0;
        this.dateFormat = JSON.parse(localStorage.getItem('permission'))[0];
        this.invoiceInfo1 = this.selectedCustomerInfo.Invoice_Details;
        //this.todayD = moment(this.invoiceInfo[0].Invoice_Date).format(this.dateFormat.dateInputFormat);
        // this.todayD = moment(this.salesorder.Return_Invoice_Date).format(this.dateFormat.dateInputFormat);
      //   console.log(this.selectedCustomerInfo.Customer_Name);
        this.invoiceInfo = JSON.parse(this.selectedCustomerInfo.Invoice_Details);
        if(this.invoiceInfo.length > 0 && this.invoiceInfo[0].Invoice_Date != null){
            let invoice = this.invoiceInfo.sort((val1, val2) => {return <any>(new Date(val2.Invoice_Date)) - <any>(new Date(val1.Invoice_Date))});
            var diff = Math.abs(new Date().getTime() - new Date(invoice[0].Invoice_Date).getTime());
            this.selectedCustomerInfo.LastInvoiceDays = Math.floor(diff / (1000 * 3600 * 24));
        }
        if(this.invoiceInfo[0].Invoice_Date){
            this.todayD = moment(this.invoiceInfo[0].Invoice_Date).format(this.dateFormat.dateInputFormat);
        }else{
            this.todayD = '';
        }
       
        //console.log("INvoice Date =======> :",this.todayD);
        //console.log("INvoice Date =======> :",this.invoiceInfo1);

      //   console.log(this.invoiceInfo);
    }


    onCustSelectionChanged(event) {
        this.custSelectionMain(this);
    }
    quickSearch(event, id) {
       /*  if (id == 'product') {
            // this.gridApiPrd.setQuickFilter(this.searchValue);
            // this.gridApiPrd.onFilterChanged();
            // this.gridApiPrd.getModel().getRow(0).setSelected(true);
            // this.productFilterd = this.gridApiPrd.getModel().getRowCount().toLocaleString();
            // if (event.which == 13 || event.which == 40) {
            //     this.gridApiPrd.setFocusedCell(0, "Product_Code");
            // }
        }
        else if (id == 'customer') {
          //   console.log(this.searchValue);
            this.gridApiCust.setQuickFilter(this.searchValue);
            this.gridApiCust.onFilterChanged();
            this.gridApiCust.getModel().getRow(0).setSelected(true);
            // this.productFilterd = this.gridApiPrd.getModel().getRowCount().toLocaleString();
            if (event.which == 13 || event.which == 40) {
                this.gridApiCust.setFocusedCell(0, "Customer_Code");
            }
        } */

        if (id == 'customer') {
            // this.gridApi.setQuickFilter(this.filterValue);
            var sportsFilterComponent = this.gridApiCust.getFilterInstance(this.filterType);
            if(this.searchValue){
                var search1 = this.searchValue.split(' ');
                sportsFilterComponent.setModel({
                    condition2: {
                        type: "contains",
                        filter: search1[1]
                    },
                    condition1: {
                        type: "startsWith",
                        filter: search1[0]
                    },
                    operator: "AND"
                });
            }
            
            
            
                this.gridApiCust.onFilterChanged();
                this.gridApiCust.getModel().getRow(0).setSelected(true);
                this.custFilterd = this.gridApiCust.getModel().getRowCount().toLocaleString();
            if (event.which == 13 || event.which == 40) {
                this.gridApiCust.setFocusedCell(0, "Customer_Code");
            }
        }
    }

    
    cusOSRowData: any;
    customeroutstandingDef: any;
    custOSSearch: any;

    
    private getOutstanding() {

        this.custOSSearch.Outstandingsum = 0.00;
        this.custOSSearch.ClrAmtsum = 0.00;
        this.custOSSearch.BaseAmtsum = 0.00;
        // var data = { "Unit_ID": this.unitInfo.Unit_ID, "Customer_ID": this.selectedCustomer.Customer_ID, };
        let date = new Date();
        let From_Date = moment(date).format('YYYY-MM-DD');
        let data = {
            "Company_ID": this.unitInfo.Company_ID,
            "Unit_ID": this.unitInfo.Unit_ID,
            "FiscalYear": this.unitInfo.CurrentFYear,
            "sMode": '',
            "Doctype": '',
            "PartyType": "CUS",
            "Party_ID": this.Customer_ID,
            "PostDate": From_Date,
            "FI_Id": '' 
        }
        this.busy = this.http.post('/api/purchaseinvoices/getInvoiceListForPayment', data)
            .subscribe(response => {
                let self = this;
                self.cusOSRowData = response;
              //   console.log("this.cusOSRowData", this.cusOSRowData);
                setTimeout(() => {

                    
                    self.customeroutstandingDef = [
                        // { headerName: 'Tranaction No', field: 'Transaction_No' },
                        { headerName: 'Doc No', field: 'Doc_No' ,width: 200},
                        { headerName: 'Doc Type', field: 'DocType_Desc' ,width: 200 },
                        {
                            headerName: 'Doc Date', field: 'Post_Date' ,width: 100, cellRenderer: (data) => {
                                if (data.value) {
                                    return moment(data.value).format(self.dateFormat.dateInputFormat);
                                }
                                else {
                                    return '-';
                                }
                            }
                            // return moment(data.value).format(this.dateFormat.dateInputFormat);
                        },
                        {
                            headerName: 'Due Date', field: 'Due_Date' ,width: 100, cellRenderer: (data) => {
                                if (data.value) {
                                    return moment(data.value).format(self.dateFormat.dateInputFormat);
                                }
                                else {
                                    return '-';
                                }
                            }
                        },
                        { headerName: 'Over Days', field: 'OverDays' ,width: 100, cellStyle: { 'textAlign': "right" } },
                        { headerName: 'Total Bill Amount' ,width: 150, field: 'Total_BillAmount', cellStyle: { 'textAlign': "right" } },
                        { headerName: 'Adj Amt', field: 'ClrAmt' ,width: 100, cellStyle: { 'textAlign': "right" } },
                        { headerName: 'Outstanding', field: 'Outstanding' ,width: 100, cellStyle: { 'textAlign': "right" } },
                    ];



                    let Outsgsum = self.cusOSRowData.reduce(function(acc, sum){
                        return acc + parseFloat(sum.Outstanding); 
                    }, 0); 
                    let ClrAmtsum1 = self.cusOSRowData.reduce(function(acc, sum){
                        return acc + parseFloat(sum.SumClrAmt); 
                    }, 0);
                    let BaseAmtsum = self.cusOSRowData.reduce(function(acc, sum){
                        return acc + parseFloat(sum.Base_Amt); 
                    }, 0); 
        
                    self.custOSSearch.Outstandingsum = Outsgsum.toFixed(2);
                  //   console.log("this.cusOSRowData.Outstandingsum ======>", self.custOSSearch.Outstandingsum);
                    self.custOSSearch.ClrAmtsum = ClrAmtsum1.toFixed(2);
                  //   console.log("this.cusOSRowData.ClrAmtsum ===========>", self.custOSSearch.ClrAmtsum);
                    self.custOSSearch.BaseAmtsum = BaseAmtsum.toFixed(2);
                  //   console.log("this.cusOSRowData.BaseAmtsum===========>", self.custOSSearch.BaseAmtsum); 
                }, 500);
            })


    }

    outstandingClick() {
        this.outstandingFn(this.OS);
    } 

    outstandingFn(os) {
       /*  if (this.modalService.hasOpenModals()) {
            this.modalService.dismissAll('close all to open new popup!');
        } */
        this.modalService.open(os, { size: 'sm', windowClass: 'data-show ledger' });
        //get customer outstanding
        this.custOSSearch = { "To_Date": new Date(), "From_Date": this.oneMonthAgo() };
        this.getOutstanding();
    }

    oneMonthAgo() {
        var monthAgo = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            new Date().getDate()
        );
        return monthAgo;
    }

    CustomerNotesList: any;
    GetCustomerNotes(CustID){
        
        let data = {Customer_ID:CustID};
        this.http.post('api/Salesinvoices/GET_CUSTOMER_NOTES', data)
        .subscribe(Response=>{
          //   console.log(Response);
            this.CustomerNotesList = Response;
            
        });

    } 
    CustNotescolumnDefs:any;
    prodmodalReference: NgbModalRef;

    OpenCustomerNotesPopup(){
        this.GetCustomerNotes(this.Customer_ID);
        //alert('hii');
        this.prodmodalReference = this.modalService.open(this.CustomerNotespopup, { size: 'lg', windowClass: 'data-show width75 accountposting updateWarehouseWidth' });

        this.CustNotescolumnDefs = [
            {headerName: 'Description', field: 'Description',  width:750},
            {headerName: 'Date', field: 'Notes_Date', width:100}
        ]
    }

    movepopup(ctrl){ 
        this.GetCustomerReview(this.Customer_ID);
    }

    datalist : any;
    CustomerReviewList: any;
    GetCustomerReview(id) {
        // console.log("dasdasdsadsadasdsadas",id)
        let data = {
            "Post_Account_Id": id
        };
      //   console.log("datadatadata",data)
        this.http.post('/api/SalesInvoices/GetCustomerReview', data)
        .subscribe(response => {

            this.prodmodalReference = this.modalService.open(this.cuatInfopopup, { size: 'sm', windowClass: 'data-show ledger'});

            this.CustomerReviewList = response;
            this.datalist = this.CustomerReviewList
            this.genrateBarChart();
            this.genrateLineChart();
            this.genrateLineChart1();
        });
    }

    genrateBarChart(){
      //   console.log("step 2")
        this.datalist ;
      //   console.log("newresultttttttttttttttt",this.datalist);
        var self = this;
        
       var chart = bb.generate({
           bindto: "#chart",
           data: {
               json: self.datalist,
               type: "bar",
               "colors": {
                   "SalesReturn": "#FFFF00",
                   "Sale": "#0000FF", 
                   "ReceiptAmt":"#FFA500",
                   "ExpiryReturn":"#FF0000"
                  
               },
                   keys: {
                       x: "Doc_Date", // it's possible to specify "x" when category axis
                       value: ["SalesReturn", "Sale", "ReceiptAmt" , "ExpiryReturn"],
                   }
           },
           size: {
                width: 800,
                height: 200
            },
           axis: {
               x: {
                    type: "category",
                    
               }
           },
           bar : { 
               width : {
                   ratio : 1,
                   max : 20
               }
           },     
        
           
        });
   }

   genrateLineChart(){
    // console.log("step 2")
    this.datalist ;
  //   console.log("newresultttttttttttttttt",this.datalist);
    var self = this;
    
   var chart = bb.generate({
       bindto: "#LineChart",
       data: {
            json: self.datalist,
                "colors": {
                    "Sale": "#0000FF", 
                    // "SalesReturn": "#FFFF00",
                    // "ReceiptAmt":"#FFA500",
                    // "ExpiryReturn":"#FF0000"
                
                },
                keys: {
                    x: "Doc_Date", // it's possible to specify "x" when category axis
                    value: ["Sale"],
                },
            },
            size: {
                width: 500,
                height: 200
            },
            axis: {
                x: {
                    type: "category",
                    
                }
            },
            bar : { 
                width : {
                    ratio : 0.1,
                    max : 5
                }
            },

        });
        
    
    }

    genrateLineChart1(){
      //   console.log("step new")
        this.datalist ;
      //   console.log("newresultttttttttttttttt",this.datalist);
        var self = this;
        
    var chart = bb.generate({
        bindto: "#LineChart1",
        data: {
            json: self.datalist,
                "colors": {
                    "ReceiptAmt":"#FFA500"
                    // "Sale": "#0000FF", 
                    // "SalesReturn": "#FFFF00",
                    // "ReceiptAmt":"#FFA500",
                    // "ExpiryReturn":"#FF0000"
                
                },
                keys: {
                    x: "Doc_Date", // it's possible to specify "x" when category axis
                    value: ["ReceiptAmt"],
                }
            },
            size: {
                width: 500,
                height: 200
            },
            axis: {
                x: {
                    type: "category",
                    
                }
            },
            bar : { 
                width : {
                    ratio : 0.1,
                    max : 5
                }
            },

        });    
    }

    SalesHistcolumnDefs:any;
    SalesHistList:any;
    SearchModel:any;
    OpenSalesHistoryPopup(SalesHistorypopup){
        this.SalesHistList = [];
        if(!this.selectedCustomerInfo.Customer_ID){
            this.toastWarningMsg("Customer Not Selected");
            return;
        }
        this.SearchModel = { "From_Date": new Date(), "To_Date": new Date() };  
        this.modalService.open(SalesHistorypopup, { size: 'lg', windowClass: 'data-show ProductPopup' });
        setTimeout(() => {
            $('input[name=From_Date]').focus().select();
        }, 100);
        this.SalesHistcolumnDefs = [
            {headerName: 'Inv No', field: 'Invoice_No', width: 120 },
            {headerName: 'Inv Date', field: 'Invoice_Date', width: 100 },
            {headerName: 'Product Code', field: 'Product_Code', width: 120 },
            {headerName: 'Product Name', field: 'Product_Desc', width: 150 },
            {headerName: 'Batch No', field: 'Batch_No', width: 100 },
            {headerName: 'Exp Date', field: 'Expiry_Date', width: 80 },
            {headerName: 'Qty', field: 'Entry_Qty', width: 70, cellStyle: {'text-align': 'right'} },
            {headerName: 'FQty', field: 'Free_Qty', width: 70, cellStyle: {'text-align': 'right'} },
            {headerName: 'MRP', field: 'MRP', width: 100, cellStyle: {'text-align': 'right'} },
            {headerName: 'PTR', field: 'PTR', width: 100, cellStyle: {'text-align': 'right'} },
            {headerName: 'Rate', field: 'Rate', width: 100, cellStyle: {'text-align': 'right'} },
            {headerName: 'Taxable Amt', field: 'Taxable_Amount', width: 100, cellStyle: {'text-align': 'right'} },
        ];
        this.GetCustomerSalesHistory();     
    }

    GetCustomerSalesHistory(){
        let data = {"Customer_ID": this.selectedCustomerInfo.Customer_ID, "Unit_ID": this.unitInfo.Unit_ID, "Company_ID": this.unitInfo.Company_ID, "From_Date": moment(this.SearchModel.From_Date).format('YYYY-MM-DD'),"To_Date": moment(this.SearchModel.To_Date).format('YYYY-MM-DD') };
        this.http.post('api/Salesinvoices/Get_Customer_Sales_History', data)
        .subscribe(Response=>{
            this.SalesHistList = Response;
            setTimeout(() => {
                $('input[name=From_Date]').focus().select();
            }, 100);     
        });
    }

    From_Datechange(e){
        if(e.which == 13){
            $('#To_Date').focus();
        }
    }

    To_Datechange(e){
      //   console.log("e.which",e.which);
        if(e.which == 13){
            $('#okbtn1').focus();
        }
    }

    clearAllFilter() {
        this.searchValue = '';
    }
    ProductDetailsHeaderList: any;
    custLedgercolumnDefs: any;
    ExpiryLedgercolumnDefs: any;
    ExpiryLedgerDatacolumnDefs: any;
    custLedgerRowData: any;
    custLedgerRowDataFooter: any; 
    
    ExpiryLedgerRowData: any;
    ExpiryLedgerRowDataList: any;

    ExpiryLedgerRowDataFooter: any;
    ledgerDetails: any;
    ExpiryledgerDetails: any;
    ledgerDebit: any;
    ExpiryledgerDebit: any;
    ledgerCredit: any;
    ExpiryledgerCredit: any;
    ledgerClosingBalance: any;
    ExpiryledgerClosingBalance: any;
    ledgerOpeningBalance: any;
    ExpiryledgerOpeningBalance: any;
    ExpiryledgerDueBalance: any;
    ledgerSearch: any;

    ledgerModal(ledger) {
        /* if (!this.modalService.hasOpenModals()) { */
            this.modalLadgerReference = this.modalService.open(ledger, { size: 'lg', windowClass: 'data-show ledger-modal-popup' });
            this.customerLedger();
            setTimeout(() => {
                $('.ledger-modal-popup input#From_Date').focus().select();
                this.initModalQuery('.ledger-modal-popup');
            }, 200);
            this.ledgerSearch.From_Date = this.oneMonthAgo();
            this.ledgerSearch.To_Date = new Date();
        /* } */
    }

    gridApicustLedger: any;
    gridColumnApicustLedger: any;
    custLedgerGridReady(params) {
        this.gridApicustLedger = params.api;
        this.gridColumnApicustLedger = params.columnApi;
        this.gridApicustLedger.sizeColumnsToFit();
    }
    
    customerLedger() {

        if (this.ledgerSearch.From_Date == null || this.ledgerSearch.From_Date == "") {
            this.toastWarningMsg("From Date cannot be blank!");
            setTimeout(() => {
                $('#From_Date').focus();
            }, 300);
            return false;
        }
        else if (this.ledgerSearch.To_Date == null || this.ledgerSearch.To_Date == "") {
            this.toastWarningMsg("To Date cannot be blank!");
            setTimeout(() => {
                $('#To_Date').focus();
                return false;
            }, 300);
        }
        else if (Date.parse(this.ledgerSearch.To_Date) < Date.parse(this.ledgerSearch.From_Date)) {
            this.toastWarningMsg("From date cannot be greater than to date!");
            setTimeout(() => {
                $('#To_Date').focus();
                return false;
            }, 300);
        }
        else {
            this.selectedCustomer = this.gridApiCust.getSelectedRows();
            let To_Date = moment(this.ledgerSearch.To_Date).format('YYYY-MM-DD');
            let From_Date = moment(this.ledgerSearch.From_Date).format('YYYY-MM-DD');
            var data = {
                "Customer_ID": this.selectedCustomerInfo.Customer_ID, "Unit_ID": this.unitInfo.Unit_ID, "Company_ID": this.unitInfo.Company_ID,
                "From_Date": From_Date, "To_Date": To_Date
            };
            //console.log("data", data);
            this.custLedgerRowData = [];
            this.busy = this.http.post('/api/customers/Get_Ledger_Customer_Wise', data)
                .subscribe(response => {
                  //   console.log("ledger response",response);
                    var res = [];
                    res.push(response);
                    let self = this;
                    this.custLedgercolumnDefs = [
                        { headerName: 'Doc No', field: 'TransNo', width: 100  }
                           /*  cellRenderer: {
                                onClick: this.NavigateScreen.bind(this),
                                icon: 'fas fa-trash'
                                , cellStyle: { text: underline
                            },
                         */
                      /*   cellRenderer: (params) => {
                               self.NavigateScreen(params.data);
                            } */
                        ,
                        { headerName: 'Doc Type', field: 'DocType_Desc', width: 100 },
                        {
                            headerName: 'Date', field: 'Doc_Date', width: 200,
                            cellRenderer: (data) => {
                                if (data.value) {
                                    return moment(data.value).format(self.dateFormat.dateInputFormat);
                                }
                                else {
                                    return '-';
                                }
                            }
                        },
                        { headerName: 'Remarks', field: 'Remarks', width: 150},
                        { headerName: 'Debit', field: 'Debit', width: 200 ,cellStyle :{ textAlign : 'right'} },
                        { headerName: 'Credit', field: 'Credit', width: 100 ,cellStyle :{ textAlign : 'right'} },
                        { headerName: 'Balance', field: 'Balance', width: 100 ,cellStyle :{ textAlign : 'right'} },
                        { headerName: '', field: 'DRCR', width: 50  },
                    ];

                   
                    // this.custLedgerRowData = res;
                    this.custLedgerRowData = res[0].ledgerData;
                    this.custLedgerRowDataFooter = res[0].ledgerFooterData;
                    this.ledgerDetails = this.custLedgerRowDataFooter[0];
                    this.ledgerDebit = this.ledgerDetails.Debit;
                    this.ledgerCredit = this.ledgerDetails.Credit;
                    this.ledgerClosingBalance = this.ledgerDetails.Closing_Balance;
                    this.ledgerOpeningBalance = this.ledgerDetails.Opening_Balance;
                    // console.log("ledgerDetails", this.ledgerDetails);

                    if (this.custLedgerRowData.length > 0) {
                        setTimeout(() => {
                            let allColumnIds = [];
                            this.gridApicustLedger.getModel().getRow(0).setSelected(true);
                            this.gridApicustLedger.setFocusedCell(0, "Party_Code");
                            this.gridColumnApicustLedger.getAllColumns().forEach(function (column) {
                                allColumnIds.push(column.colId);
                            });
                            this.gridColumnApicustLedger.autoSizeColumns(allColumnIds);
                            this.gridApicustLedger.sizeColumnsToFit();
                            
                           
                        }, 100);
                    }else{
                        setTimeout(() => {
                            let allColumnIds = [];
                            this.gridColumnApicustLedger.getAllColumns().forEach(function (column) {
                                allColumnIds.push(column.colId);
                            });
                            this.gridColumnApicustLedger.autoSizeColumns(allColumnIds);
                            this.gridApicustLedger.sizeColumnsToFit();
                        }, 100);
                    }
                    this.rowClassRules = {
                        "solution-solved": function (params) {
                            // console.log("params", params);
                            var Status_ID = params.data.Reconciled;
                            return Status_ID == 1;
                        }
                    };
                })
        }

     

    }

    initModalQuery(className) {
        var parent = this;
        // let jqueryclass = className + ' ul.form-group';
        $(className).on('keydown', 'input, select, textarea, input[role=combobox]', function (e) {
          //   console.log("enter");
            var self = $(this)
                , form = self.parents(className + ':eq(0)')
                , focusable
                , next
                ;
            if (e.keyCode == 13) {
                if(this.classList.contains('custom-date')){
                    parent.customDateFormat.GetCustomDateFormat(this, parent.datePipe);
                }
                focusable = form.find('input:not([type="radio"]), input[role=combobox]').filter(':visible');
                next = focusable.eq(focusable.index(this) + 1);
                if (next.length) {
                    next.focus().select();
                } else {
                    $('#okbtn').focus();
                }
                return false;
            }
        });
    }
 
    ledgerRowSelected: any = [];
    ledgeronSelectionChanged() {
        var selectedRows = this.gridApicustLedger.getSelectedRows();
        this.ledgerRowSelected = selectedRows[0];
        //console.log("selectedRows", selectedRows);
    }



    expiryLedgerModal(expiryLedger) {
      /*   if (!this.modalService.hasOpenModals()) { */
            this.getAllExpiryLedger();
             this.modalService.open(expiryLedger, { size: 'lg', windowClass: 'data-show order-history-modal' });
            setTimeout(() => {
                $('.order-history-modal input#From_Date').focus().select();
                this.initModalQuery('.order-history-modal');
            }, 200);
            // $("#From_Date").focus();
    
            this.orderSearch.From_Date = this.oneMonthAgo();
            this.orderSearch.To_Date = new Date();
       /*  } */
    }

    
    gridApiExpLdge: any;
    gridColumnApiExpLdge: any;
    expiryLedgerGridReady(params) {
        this.gridApiExpLdge = params.api;
        this.gridColumnApiExpLdge = params.columnApi;
        this.gridApiExpLdge.sizeColumnsToFit();
    }
    getAllExpiryLedger() {
        $(document).ready(function(){
            $('.ag-root.ag-layout-normal').css('overflow','inherit');
            $('.ag-root.ag-layout-normal').css('width','auto');
        });
        if (this.ledgerSearch.From_Date == null || this.ledgerSearch.From_Date == "") {
            this.toastWarningMsg("From Date cannot be blank!");
            setTimeout(() => {
                $('#From_Date').focus();
            }, 300);
            return false;
        }
        else if (this.ledgerSearch.To_Date == null || this.ledgerSearch.To_Date == "") {
            this.toastWarningMsg("To Date cannot be blank!");
            setTimeout(() => {
                $('#To_Date').focus();
                return false;
            }, 300);
        }
        else if (Date.parse(this.ledgerSearch.To_Date) < Date.parse(this.ledgerSearch.From_Date)) {
            this.toastWarningMsg("From date cannot be greater than to date!");
            setTimeout(() => {
                $('#To_Date').focus();
                return false;
            }, 300);
        }
        else {

            let To_Date = moment(this.ledgerSearch.To_Date).format('YYYY-MM-DD');
            let From_Date = moment(this.ledgerSearch.From_Date).format('YYYY-MM-DD');
            var data = {
                "Customer_ID": this.selectedCustomerInfo.Customer_ID, "Unit_ID": this.unitInfo.Unit_ID, "Company_ID": this.unitInfo.Company_ID,
                "From_Date": From_Date, "To_Date": To_Date
            };
            //console.log("data", data); Get_Ledger_Customer_Wise   
            this.ExpiryLedgerRowData = [];
            this.ExpiryLedgerRowDataList = [];
            this.busy = this.http.post('/api/customers/Get_Expity_Ledger_Customer_Wise', data)
            .subscribe(response => {
              //   console.log("Expiry ledger response",response);
                var res = [];
                res.push(response);
                let self = this;
                this.ExpiryLedgercolumnDefs = [
                    { headerName: 'Doc No', field: 'TransNo', width: 100 },
                    {
                        headerName: 'Date', field: 'Doc_Date', width: 200,
                        cellRenderer: (data) => {
                            if (data.value) {
                                return moment(data.value).format(self.dateFormat.dateInputFormat);
                            }
                            else {
                                return '-';
                            }
                        }
                    },
                    { headerName: 'Debit', field: 'Debit', width: 100 ,cellStyle :{ textAlign : 'right'} },
                    { headerName: 'Credit', field: 'Credit', width: 100 ,cellStyle :{ textAlign : 'right'} },
                    { headerName: 'Due/Reference', field: 'Balance', cellStyle :{ textAlign : 'right'} },
                    { headerName: '', field: 'Flagexyz', width: 50  },
                    { headerName: '', field: 'DRCR', width: 50  }
                ];


                this.ExpiryLedgerDatacolumnDefs = [
                    { headerName: 'Doc No', field: 'TransNo', width: 100 },
                    {
                        headerName: 'Date', field: 'Doc_Date', width: 200,
                        cellRenderer: (data) => {
                            if (data.value) {
                                return moment(data.value).format(self.dateFormat.dateInputFormat);
                            }
                            else {
                                return '-';
                            }
                        }
                    },
                    { headerName: 'Amount', field: 'Invoice_Amount', width: 100 ,cellStyle :{ textAlign : 'right'} },
                    { headerName: 'Remark', field: 'Remarks', width: 200},
                
                ];
               
                // this.custLedgerRowData = res;  Expiry
                this.ExpiryLedgerRowData = res[0].ledgerData;
                this.ExpiryLedgerRowDataFooter = res[0].ledgerFooterData;
                this.ExpiryledgerDetails = this.ExpiryLedgerRowDataFooter[0];
                this.ExpiryledgerDebit = this.ExpiryledgerDetails.Debit;
                this.ExpiryledgerCredit = this.ExpiryledgerDetails.Credit;
                this.ExpiryledgerClosingBalance = this.ExpiryledgerDetails.Closing_Balance;
                this.ExpiryledgerOpeningBalance = this.ExpiryledgerDetails.Opening_Balance;
                this.ExpiryledgerDueBalance = this.ExpiryledgerDetails.DueBalance;
                // console.log("ledgerDetails", this.ledgerDetails);

                if (this.ExpiryLedgerRowData.length > 0) {
                    setTimeout(() => {
                        let allColumnIds = [];
                        this.gridApiExpLdge.getModel().getRow(0).setSelected(true);
                        this.gridApiExpLdge.setFocusedCell(0, "TransNo");
                        this.gridColumnApiExpLdge.getAllColumns().forEach(function (column) {
                            allColumnIds.push(column.colId);
                        });
                        this.gridColumnApiExpLdge.autoSizeColumns(allColumnIds);
                        this.gridApiExpLdge.sizeColumnsToFit();
                        
                       
                    }, 100);
                }else{
                    setTimeout(() => {
                        let allColumnIds = [];
                        this.gridColumnApiExpLdge.getAllColumns().forEach(function (column) {
                            allColumnIds.push(column.colId);
                        });
                        this.gridColumnApiExpLdge.autoSizeColumns(allColumnIds);
                        this.gridApiExpLdge.sizeColumnsToFit();
                    }, 100);
                }
                this.rowClassRules = {
                    "solution-solved": function (params) {
                        // console.log("params", params);
                        var Status_ID = params.data.Reconciled;
                        return Status_ID == 1;
                    }
                };
            })
        } 

    }
    expiryLedgerSelectionChanged() {
        var selectedRows = this.gridApiExpLdge.getSelectedRows();
        //console.log("selectedRows", selectedRows);
    }
    exportExcelExpiryLedger() {
        let To_Date = moment(this.ledgerSearch.To_Date).format('DD-MMM-YYYY');
        let From_Date = moment(this.ledgerSearch.From_Date).format('DD-MMM-YYYY');
        let row =  this.unitInfo.Company_Name +  '\n' + this.unitInfo.Company_Full_Address +  '\n' + 'Customer Name :' + this.selectedCustomer.Customer_LegalName +  '\n'+ 'From : ' + From_Date + ',' + 'To : ' + To_Date
        let d = new Date();
        var fName = 'Order_History_' + d.getTime();
        var params = {
            columnGroups: true,
            skipFooters: false,
            allColumns: true,
            customHeader: row,
            fileName: fName,
        };
        this.gridApiExpLdge.exportDataAsCsv(params);
    }   

    ExpiryledgerRowSelected: any = [];
    gridApiExpLdgeData: any;
    gridColumnApiExpLdgeData: any;
    ExpiryledgeronSelectionChanged() {
        var self = this;
        var selectedRows = this.gridApiExpLdge.getSelectedRows();
        this.ExpiryledgerRowSelected = selectedRows[0];
      //   console.log("selectedRows", this.ExpiryledgerRowSelected.Sales_Breakage_Expiry_ID);
       
        if(this.ExpiryledgerRowSelected.Sales_Breakage_Expiry_ID > 0){
            var data = {"Transaction_Ref_No":this.ExpiryledgerRowSelected.Sales_Breakage_Expiry_ID}
            this.busy = this.http.post('/api/customers/Get_Adjusted_Document', data)
            .subscribe(response => {
                this.ExpiryLedgerRowDataList = response;
            }) 
        }else{
            this.ExpiryLedgerRowDataList = [];
        }
        
    }

    expiryLedgerDataGridReady(params) {
        this.gridApiExpLdgeData = params.api;
        this.gridColumnApiExpLdgeData = params.columnApi;
        this.gridApiExpLdgeData.sizeColumnsToFit();
    }



   
}
